import { render } from "./PackageDetail.vue?vue&type=template&id=141e0a0d&ts=true"
import script from "./PackageDetail.vue?vue&type=script&lang=ts"
export * from "./PackageDetail.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__